import SkillBasedLessonApi from './SkillBasedLessonApi';
export default SkillBasedLessonApi;
